<template>
  <div class="input-wrapper all-day-wrapper position-relative">
    <span class="ver-center">Time Zone</span>
    <div class="pl-100 dropdown-container">
      <select
        :value="selectedTimezone"
        @change="setSelectedTimezone($event.target.value)"
        class="custom-select"
      >
        <option
          v-for="timezone in timezones"
          :key="timezone.id"
          :value="timezone.id"
          >{{ timezone.timezone.split(") ")[1] }}</option
        >
      </select>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("addNew", {
      timezones: "getTimezones",
      selectedTimezone: "getSelectedTimezone"
    })
  },
  methods: {
    ...mapMutations("addNew", {
      setSelectedTimezone: "setSelectedTimezone"
    })
  }
};
</script>

<style scoped>
select {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
</style>
